import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useClinicServices } from 'services'
import { serviceSelector, setServicesAction } from 'store/serviceSlice'

const useService = () => {
  const { getAllClinicService } = useClinicServices()
  const { services, isGetServiceNew } = useSelector(serviceSelector)
  const dispatch = useDispatch()
  useEffect(() => {
    if (!isGetServiceNew) {
      reloadGetALlClinicServices()
    }
  }, [])

  const reloadGetALlClinicServices = () => {
    getAllClinicService().then((res) => {
      if (res._successfully) {
        dispatch(setServicesAction(res?.data))
      }
    })
  }

  return { services, reloadGetALlClinicServices }
}

export default useService
